import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const AuthContext = createContext({
  user: null,
  loading: true,
  refresh: () => {},
  setUser: () => {},
  logout: () => {},
});

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const tok = typeof window !== "undefined" ? window.localStorage.getItem("garnacha_token") : null;
      const headers = tok ? { Authorization: `Bearer ${tok}` } : {};
      const r = await axios.get(`${API}/auth/me`, { withCredentials: false, headers });
      setUser(r.data);
      setLoading(false);
      return r.data;
    } catch (e) {
      setUser(null);
      setLoading(false);
      return null;
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      const tok = typeof window !== "undefined" ? window.localStorage.getItem("garnacha_token") : null;
      const headers = tok ? { Authorization: `Bearer ${tok}` } : {};
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: false, headers });
    } catch {/* ignore */}
    if (typeof window !== "undefined") {
      window.localStorage.removeItem("garnacha_token");
    }
    setUser(null);
    window.location.href = "/login";
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  return (
    <AuthContext.Provider value={{ user, loading, refresh, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
